import './App.css'
import CoursesOverviewPage from "./pages/course/CoursesOverviewPage.tsx";
import CoursesEnrolledPage from "./pages/course/CoursesEnrolledPage.tsx";
import CoursePage from "./pages/course/CoursePage.tsx";
import HomePage from "./pages/home/HomePage.tsx";
import AboutPage from "./pages/about/AboutPage.tsx";
import TermsOfServicePage from "./pages/legal/TermsOfServicePage.tsx";
import PrivacyPolicyPage from "./pages/legal/PrivacyPolicyPage.tsx";
import UserProfilePage from "./pages/user/UserProfilePage.tsx";
import LoginPage from "./pages/auth/LoginPage.tsx";
import RegistrationPage from "./pages/auth/RegistrationPage.tsx";
import ForgotPasswordPage from "./pages/auth/ForgotPasswordPage.tsx";
import ResetPasswordPage from "./pages/auth/ResetPasswordPage.tsx";
import RootLayout from "./layouts/root/RootLayout.tsx";
import ErrorPage from "./pages/error/ErrorPage";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AuthService from "./services/auth/AuthService";
import { setUser } from "./store/userSlice";

const router = createBrowserRouter([
    {
        path: '/',
        element: <RootLayout />,
        errorElement: <ErrorPage />,
        children: [
            { index: true, element: <HomePage /> },
            { path: '/about', element: <AboutPage /> },
            { path: '/terms', element: <TermsOfServicePage /> },
            { path: '/privacy', element: <PrivacyPolicyPage /> },
            { path: '/login', element: <LoginPage /> },
            { path: '/registration', element: <RegistrationPage /> },
            { path: '/forgot-password', element: <ForgotPasswordPage /> },
            { path: '/reset-password', element: <ResetPasswordPage /> },
            { path: '/courses', element: <CoursesOverviewPage /> },
            { path: '/courses/:courseId/:chapterId/:lessonId', element: <CoursePage /> },
            { path: '/courses-enrolled', element: <CoursesEnrolledPage /> },
            { path: '/user-profile', element: <UserProfilePage /> },
        ],
    },
]);

function App() {
    const dispatch = useDispatch();
    const [ready, setReady] = useState(false);

    // On first load / refresh: if a token is stored, restore the logged-in
    // user from the API so the session survives a page reload. If the token
    // is missing or invalid, we just render logged-out (the privateClient
    // 401 interceptor clears a bad token and redirects to /login).
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) { setReady(true); return; }
        AuthService.fetchCurrentUser()
            .then((user) => dispatch(setUser(user)))
            .catch(() => {})
            .finally(() => setReady(true));
    }, [dispatch]);

    if (!ready) return null; // avoids a flash of the logged-out UI

    return <RouterProvider router={router} />;
}

export default App
